import { Injectable } from '@angular/core'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { TmrODataConfiguration } from '@exchange/services/core/odata/config'
import { ODataService, TransformationService } from 'common-services'

export interface IRemitLineX12 extends IModelBase {
  LeftEdiFileRevisionId: number
  Left: string
  LeftDate: Date
  RightEdiFileRevisionId: number
  Right: string
  RightDate: Date
}

@Injectable()
export class RemitLineX12TransformationService extends TransformationService<IRemitLineX12> {
  constructor() {
    super()
  }

  responseTransformArray(response: any, method: string): IRemitLineX12[] {
    response = [].concat(response)
    response = response.map(x => {
      x.Id = '1'
      return x
    })
    return response
  }
}

@Injectable()
export class RemitLineX12ODataService extends ODataService<IRemitLineX12> {
  constructor(
    protected http: HttpClient,
    protected config: TmrODataConfiguration,
    protected idTransformService: RemitLineX12TransformationService
  ) {
    super(http, config, idTransformService)
    this.typeName = 'EdiComparisonView'
  }
}
